import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { LibraryAsset } from 'app/library-assets/models/library-asset';
import { LibraryAssetResult } from 'app/library-assets/models/library-asset-result';

@Component({
  selector: 'dac-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.scss']
})
export class ArticleComponent implements OnInit {

  @Input() article:LibraryAsset;
  @Input() result:LibraryAssetResult;
  @Output() onSubmit = new EventEmitter<LibraryAssetResult>();
  @Input("disabled") disabled:Boolean;
  @Input() hideHeaders:boolean;

  public ArticleContent:string;

  constructor() { 
    this.hideHeaders = false;
  }

  ngOnInit() {
    // we've sanitized this on the server, and we need to get the ids 
    if (this.article && this.article.content) {
      this.ArticleContent = this.article.content;
    }
  }

  public print() {
    if (window && window.print) {
      window.print();
    }
  }

  public submit() {
   
    let result = new LibraryAssetResult();
    result.asset = this.article;
    result.answers = []; // answers have to be an empty array
    result.journal = null;
    this.onSubmit.next(result);
  }

}



// WEBPACK FOOTER //
// ./src/app/library-assets/article/article.component.ts